module.exports = __webpack_public_path__ + "static/breathe-d82525fe6952a59f392dfb077e30c1fb.webp";